import baseApi, { TAGS } from '../api/baseApi';

/************************************************** API **************************************************/
const taxProConsultationApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getTaxProAuthInfo: builder.query({
      query: () => ({
        url: 'tax-pro-consultation/auth-information',
        method: 'GET'
      }),
      transformResponse: (response) => response.data,
      providesTags: [TAGS.TAX_PRO_CONSULTATION_AUTH]
    }),
    getTaxPros: builder.query({
      query: () => ({
        url: 'tax-pro-consultation/tax-pros',
        method: 'GET'
      }),
      transformResponse: (response) => response.data.taxPros,
      providesTags: [TAGS.TAX_PRO_CONSULTATION_TAX_PROS]
    }),
    authorizeGoogleCalendar: builder.mutation({
      query: ({ code, state }) => ({
        url: 'tax-pro-consultation/auth-google-calendar',
        method: 'POST',
        body: { code, state }
      }),
      transformResponse: (response) => response.data,
      invalidatesTags: [TAGS.TAX_PRO_CONSULTATION_AUTH]
    }),
    authorizeZoom: builder.mutation({
      query: ({ code, state }) => ({
        url: 'tax-pro-consultation/auth-zoom',
        method: 'POST',
        body: { code, state }
      }),
      transformResponse: (response) => response.data,
      invalidatesTags: [TAGS.TAX_PRO_CONSULTATION_AUTH]
    }),
    getMeetingInfo: builder.query({
      query: ({ userId }) => ({
        url: `tax-pro-consultation/meeting-info`,
        params: { userId },
        method: 'GET'
      }),
      transformResponse: (response) => response.data,
      providesTags: [TAGS.TAX_PRO_CONSULTATION_MEETING_INFO]
    }),
    updateMeetingInfo: builder.mutation({
      query: ({ meetingId, taxProNotes, isNoShow }) => ({
        url: `tax-pro-consultation/meeting-info`,
        method: 'PATCH',
        body: { meetingId, taxProNotes, isNoShow }
      }),
      transformResponse: (response) => response.data,
      invalidatesTags: [TAGS.TAX_PRO_CONSULTATION_MEETING_INFO]
    }),
    setAllowedAdditionalCall: builder.mutation({
      query: ({ userId, isAllowedAdditionalCall }) => ({
        url: 'tax-pro-consultation/set-allowed-additional-call',
        method: 'POST',
        body: { userId, isAllowedAdditionalCall }
      }),
      transformResponse: (response) => response.data,
      invalidatesTags: [TAGS.TAX_PRO_CONSULTATION_MEETING_INFO]
    }),
    deleteTaxPro: builder.mutation({
      query: ({ taxProId }) => ({
        url: `tax-pro-consultation/tax-pro/${taxProId}`,
        method: 'DELETE'
      }),
      transformResponse: (response) => response.data,
      invalidatesTags: [TAGS.TAX_PRO_CONSULTATION_TAX_PROS, TAGS.USER_LIST]
    })
  })
});

/************************************************** HOOKS **************************************************/
export const {
  useGetTaxProAuthInfoQuery,
  useAuthorizeGoogleCalendarMutation,
  useAuthorizeZoomMutation,
  useGetMeetingInfoQuery,
  useUpdateMeetingInfoMutation,
  useSetAllowedAdditionalCallMutation,
  useGetTaxProsQuery,
  useDeleteTaxProMutation
} = taxProConsultationApi;
